import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { ContaReceberContext } from 'app/main/contareceber/contaReceberContext';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext } from 'react';
import ContaReceberBuscaAvancadaForm from '../ContaReceberBuscaAvancadaForm';
import { contaReceberModais } from './contaReceberModais';

const ContasReceberBuscaAvancadaModal = ({ fetchContasReceber }) => {
  const [modal, setModal] = useContext(ContaReceberContext).modal;
  const [filtroAvancado, setFiltroAvancado] = useContext(ContaReceberContext).filtroAvancado;
  const [search] = useContext(ContaReceberContext).search;
  const [size] = useContext(ContaReceberContext).size;
  const [sort] = useContext(ContaReceberContext).sort;

  const handleSubmit = (values) => {
    setFiltroAvancado(values);
    fetchContasReceber({ q: search, filtroAvancado: values, size, sort });
    setModal('');
  };

  const handleCancelar = () => {
    setModal('');
  };

  const formik = useFormik({
    initialValues: {
      mesCompetencia: filtroAvancado.mesCompetencia,
      situacao: filtroAvancado.situacao,
    },
    onSubmit: handleSubmit,
  });

  return (
    <SimpleDialog open={modal === contaReceberModais.buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca Avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<ContaReceberBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ContasReceberBuscaAvancadaModal;
